module.exports = __webpack_public_path__ + "static/media/travel.6588aed3.png";